import { useState } from 'react';
import { IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { markProjectAsFavourite } from '../../../modules/project';
import { useNotification } from '../../../hooks/NotificationContext';

function FavouriteProjectToggle({
  projectId,
  isMarkedFavourite = false,
  size = 'medium',
  refetch = () => {},
}) {
  const [isFavourite, setIsFavourite] = useState(isMarkedFavourite);
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();

  const handleToggle = async () => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await markProjectAsFavourite(projectId, !isFavourite);

      setIsFavourite(!isFavourite);
      refetch();
      addNotification('success', response.message);
    } catch (error) {
      addNotification('error', error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <IconButton
      onClick={handleToggle}
      aria-label="Toggle favourite"
      size={size}
      color="warning"
      disabled={loading}>
      {isFavourite ? <StarIcon /> : <StarBorderIcon />}
    </IconButton>
  );
}

export default FavouriteProjectToggle;
